import Box from '@mui/material/Box'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

import Button from '@/shared/Button'
import { useTranslation } from 'react-i18next'

const SmsDialog = ({ details, title, ...props }) => {
  const { senderPhone, smsContent } = details || {}
  const { onClose } = props

  const { t } = useTranslation()

  return (
    <Dialog {...props} fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Box sx={{ backgroundColor: '#ecf1f2', padding: 2, fontSize: 14 }}>
          <Grid item container spacing={1}>
            <Grid item xs={3}>
              <Typography variant="subtitle2" sx={{ color: '#555' }}>
                {t('general.sender_phone')}
              </Typography>
            </Grid>
            <Grid item>
              <Box display="flex" alignItems="flex-end">
                {senderPhone}
              </Box>
            </Grid>
          </Grid>
        </Box>
        <div dangerouslySetInnerHTML={{ __html: smsContent }} />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()}>{t('general.close')}</Button>
      </DialogActions>
    </Dialog>
  )
}

export default SmsDialog
